import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX_PATTERNS } from '../utils/regex-patterns';

export class CustomValidators {
  static emailFormat(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    
    if (!REGEX_PATTERNS.EMAIL.test(control.value)) {
      return { emailFormat: true };
    }
    return null;
  }

  static passwordStrength(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    
    if (control.value.length < 8) {
      return { minLength: { requiredLength: 8, actualLength: control.value.length } };
    }
    
    if (!REGEX_PATTERNS.PASSWORD.test(control.value)) {
      return { passwordStrength: true };
    }
    return null;
  }

  static required(control: AbstractControl): ValidationErrors | null {
    if (!control.value || control.value.trim() === '') {
      return { required: true };
    }
    return null;
  }
}
